import { Box } from "@mui/material";
import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import { useMaterialUIController, setLayout } from "../../../context";
import { SIDENAV_LAYOUT_MARGIN_PX, SIDENAV_MINI_LAYOUT_MARGIN_PX } from "../../../lib/ui/sidenavLayout";
import { PAGE_LAYOUT_GUTTER } from "../../../lib/ui/pageLayout";

function DashboardLayout({ children }: any) {
  const [controller, dispatch] = useMaterialUIController();
  const { sidenavPinned } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname, dispatch]);

  return (
    <Box
      sx={({ breakpoints, transitions }: any) => ({
        px: PAGE_LAYOUT_GUTTER,
        py: PAGE_LAYOUT_GUTTER,
        position: "relative",
        minWidth: 0,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        height: "100dvh",
        maxHeight: "100dvh",
        overflow: "hidden",

        [breakpoints.up("lg")]: {
          marginLeft: sidenavPinned ? `${SIDENAV_LAYOUT_MARGIN_PX}px` : `${SIDENAV_MINI_LAYOUT_MARGIN_PX}px`,
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {children}
    </Box>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
